import { Component, Vue, Watch } from 'vue-property-decorator'
import { getMessageRemind, setMessageRemindById, messageRemindExportData } from '@/api/message'
import io from 'socket.io-client'
import { UserModule } from '@/store/modules/user'
import { MessageModule } from '@/store/modules/message'
import realTimeSokcet from '@/utils/socket.io'
import { delNullProperty } from "@/utils/index";
import { formatDate } from '@/utils/timeFilter'

@Component({})
export default class MessageRemind extends Vue {
  // ------ 变量 ------
  tableData = []
  page = 1
  total = 0
  pageSize = 20
  title = ''
  name = ''
  socket = null
  maketClueID = ''
  content = ''  //提醒内容
  dialogShow = false
  tableLoading = false
  exportButtonDisabled = false
  createdAt: Date[] | null = null //提醒时间
  timer = null
  // isReadonly = false


  get userId() {
    return UserModule.userId
  }

  created() {
    const phone: any = this.$route.query.phone ? this.$route.query.phone: ''
    window.localStorage.setItem("phone", phone);
    this.getTableData()
    if (this.userId) this.initSocket()
  }
  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  async getTableData() {
    MessageModule.getMessageCount()
    this.tableLoading = true

    const obj = {
      page: this.page,
      limit: this.pageSize,
      title: this.title,
      name: this.name,
      content: this.content,
      createdAt: this.changeTime(this.createdAt as Date[]), //提醒时间
    }
    const data: any = await getMessageRemind(delNullProperty(obj))
    this.total = data.allNum
    this.tableData = data.messageRemindList
    this.tableLoading = false

    //在执行完跳转页码的数据请求后
    this.$nextTick(() => {
      (this.$refs.table as HTMLFormElement).bodyWrapper.scrollTop = 0
    })
    MessageModule.SET_REMIND_BADGE(false)
  }


  // 导出
  async exportData() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    messageRemindExportData(delNullProperty({
        name: this.name,
        title: this.title,
        content: this.content
    })).then(() => {
        this.exportButtonDisabled = false
    }).catch(() => [
        this.exportButtonDisabled = false
    ])
}

  handlechangePage(page: number) {
    this.page = page
    this.getTableData()
  }

  handleChangePageSize(size: number) {
    this.pageSize = size
    this.getTableData()
  }

  // 同意回首线索
  confirm(row) {
    // this.$confirm('同意后，客户将被退回，已填写的客户信息及跟进信息将被清除', '提示', {
    //   confirmButtonText: '确认',
    //   cancelButtonText: '取消',
    //   type: 'error'
    // }).then(async () => {
    //   await setMessageRemindById({
    //     id: row.id,
    //     status: 1
    //   })
    //   this.$message.success('同意线索收回')
    //   this.getTableData()
    // })
    this.maketClueID = row.id
    this.dialogShow = true
  }
  async dialogConfirm() {
    await setMessageRemindById({
      id: this.maketClueID,
      status: 1
    })
    this.$message.success('同意线索收回')
    this.getTableData()
    this.dialogShow = false
  }

  // 拒绝线索收回
  async cancle(row) {
    await setMessageRemindById({
      id: row.id,
      status: 2
    })
    this.$message.success('拒绝线索收回')
    this.getTableData()
  }

  initSocket() {
    const time = setInterval(() => {
      if (Vue.prototype.$socket.on) {
        realTimeSokcet(this.userId, 'Remind', this.getTableData)
        clearInterval(time)
      }
    }, 100)
    // this.socket = io('wss://gec-api-testserver.gecacademy.cn', {
    //   path: '/crmServer/socket.io',
    //   query: {
    //     userId: this.userId,
    //     room: 'defaultRoom'
    //   },
    //   transports: ["websocket", "xhr-polling", "jsonp-polling"],
    //   autoConnect: false
    // })
    // this.socket.open()
    // this.socket.on('connect', () => {
    //   console.log('-----remind连接成功-----');
    // })
    // this.socket.on(this.userId, (res) => {
    //   if (res.type === 'Remind') {
    //     this.getTableData()
    //   }
    // })
    // this.socket.on('disconnect', () => {
    //   console.log('remind断开连接');
    // })
  }

  @Watch('userId')
  handleWatchUserId() {
    this.initSocket()
  }


  // 点击行跳转详情
  async handleRowClick(row) {
    switch (row.types) {
        //订单：FinanceOrder
      case 'FinanceOrder':
        this.openPage('/newMsgOrder?id=' + row.id) // 加参数
        break;
        // 回款
      case "FinanceBackMoney":
        this.openPage('/backMoneyMsg?id=' + row.id)
        break;
        // 开票
      case 'FinanceInvoice':
        this.openPage('/makeInvoiceMsg?id=' + row.id)
        break;
        // 返佣
      case "FinanceCommission":
        this.openPage('/commissionInfoMsg?id=' + row.id)
        break;
        // 合作伙伴
      case "MarketCooperation":
        this.openPage('/cooperativePartnerMsg?id=' + row.id)
        break;
        // 市场费用
      case "FinanceMarketCost":
        this.openPage('/marketCostMSg?id=' + row.id)
        break;
        // 转化客户
      case "CustomerConversionFollow":
        this.openPage('/cancleBackClueMSg?id=' + row.id)
        break;
        // 转化客户
      case "CustomerConversion":
        this.openPage('/cancleBackClueMSg?id=' + row.id) // 加参数
        break;
        // 线索
      case "MarketClue":
        this.openPage('/marketCluwMsg?id=' + row.id) // 加参数
        break;
        // 退款
      case "FinanceRefund":
        this.openPage('/refundMSg?id=' + row.id) // 加参数
        break;
        // 撞单
      case "FinanceRepeatOrder":
        this.openPage('/repeatOrderRemindMSg?id=' + row.id) // 加参数
        break;
        // 合同
      case "FinanceContract":
        this.openPage('/contractMsg?id=' + row.id+ '&financeContractTypes=' + row.financeContractTypes) // 加参数
        break;
        // B端客户
      case "CustomerBusinessFollow":
        this.openPage('/CustomerBusinessFollowRemind?id=' + row.id) // 加参数
        break;
      //  转化客户跟进
      case "CustomerConversionFollowOne":
        this.openPage('/remindFollowRecord?id=' + row.id) // 加参数
        break;
       // 转化调入公海
      case "CustomerConversionPublic":
        this.openPage('/pubCustomerRemind?id=' + row.id) // 加参数
        break;
      //转销回款
      case "CustomerConversionResaleOrder":
        this.openPage('/resaleRemind?id=' + row.id) // 加参数
        break;
      default:
        break;
        // B端客户客户修改信息
      case "CustomerBusiness":
        this.openPage('/CustomerBusinessFollowRemind?id=' + row.id) // 加参数
        break;
      // 线索 不用加同意和拒绝
      case "MarketClueUp":
        this.openPage('/marketCluwMsg?id=' + row.id) // 加参数
        break;
    }
  }

  openPage(url: string) {
    const win = window.open(window.location.origin + this.$route.matched[0].path + url, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }
}
